import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  Image,
  StyleSheet,
} from "@react-pdf/renderer";
import { convert_usd_to_nzd } from "../../../utils/conversion";
import { useSelector } from "react-redux";

let demoData = [
  {
    canprod_id: 233,
    source_price: 8.4,
    source_pricerank: 1,
    products_data: [
      {
        brand: "kim crawford",
        category: "liquor",
        description: "No desc",
        image_url:
          "https://www.aeliadutyfree.co.nz/media/catalog/product/1/0/101206045_5147.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=300&width=240&canvas=240:300",
        latest_price: 8.4,
        pricerank: "1/2",
        product_id: 321,
        qty: 750,
        sub_category: "wine",
        title: "kim crawford sauvignon blanc 750ml",
        unit: "ml",
        url: "https://www.aeliadutyfree.co.nz/auckland/kim-crawford-sauvignon-blanc-750ml.html",
        website: "aelia_auckland",
        latest_promotions: [
          {
            date: "2024-11-23T16:38:57.239236",
            text: "3 for $39",
            price: 13,
          },
          {
            date: "2024-11-23T16:38:57.239236",
            text: "3 for $39",
            price: 13,
          },
        ],
      },
      {
        brand: null,
        category: "liquor",
        description: "No desc",
        image_url:
          "https://cdn.shopify.com/s/files/1/0591/2749/6895/files/KimCrawSB400_153x.jpg?v=1733132851",
        latest_price: 8.99,
        pricerank: "2/2",
        product_id: 65810,
        qty: 750,
        sub_category: "wine",
        title: "kim crawford hawkes bay sauv blanc 750ml",
        unit: "ml",
        url: "https://nzliquor.online/collections/wine/products/kim-crawford-hawkes-bay-sauv-blanc-750ml",
        website: "nz_liquor",
        latest_promotions: [],
      },
    ],
  },
  {
    canprod_id: 233,
    source_price: 8.4,
    source_pricerank: 1,
    products_data: [
      {
        brand: "kim crawford",
        category: "liquor",
        description: "No desc",
        image_url:
          "https://www.aeliadutyfree.co.nz/media/catalog/product/1/0/101206045_5147.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=300&width=240&canvas=240:300",
        latest_price: 8.4,
        pricerank: "1/2",
        product_id: 321,
        qty: 750,
        sub_category: "wine",
        title: "kim crawford sauvignon blanc 750ml",
        unit: "ml",
        url: "https://www.aeliadutyfree.co.nz/auckland/kim-crawford-sauvignon-blanc-750ml.html",
        website: "aelia_auckland",
        latest_promotions: [
          {
            date: "2024-11-23T16:38:57.239236",
            text: "3 for $39",
            price: 13,
          },
          {
            date: "2024-11-23T16:38:57.239236",
            text: "3 for $39",
            price: 13,
          },
        ],
      },
      {
        brand: null,
        category: "liquor",
        description: "No desc",
        image_url:
          "https://cdn.shopify.com/s/files/1/0591/2749/6895/files/KimCrawSB400_153x.jpg?v=1733132851",
        latest_price: 8.99,
        pricerank: "2/2",
        product_id: 65810,
        qty: 750,
        sub_category: "wine",
        title: "kim crawford hawkes bay sauv blanc 750ml",
        unit: "ml",
        url: "https://nzliquor.online/collections/wine/products/kim-crawford-hawkes-bay-sauv-blanc-750ml",
        website: "nz_liquor",
        latest_promotions: [],
      },
    ],
  },
];
const styles = StyleSheet.create({
  page: { padding: 30, fontFamily: "Helvetica", backgroundColor: "#f4f4f4" },
  headerSection: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 20,
    borderBottom: "2px solid #bdc3c7",
    paddingBottom: 10,
  },
  logo: { width: 50, height: 50 },
  documentTitle: {
    fontSize: 26,
    fontWeight: "bold",
    color: "#2c3e50",
    letterSpacing: 1.2,
  },
  section: {
    marginBottom: 25,
    padding: 20,
    border: "1px solid #d6dde3",
    borderRadius: 8,
    backgroundColor: "#f9fbfd",
  },
  header: {
    fontSize: 22,
    marginBottom: 15,
    fontWeight: "bold",
    color: "#34495e",
    borderBottom: "3px solid #3498db",
    paddingBottom: 8,
  },
  commonDataRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 8,
  },
  commonDataLabel: {
    fontWeight: "bold",
    color: "#34495e",
    width: "40%",
  },
  commonDataValue: {
    textAlign: "right",
    color: "#2c3e50",
    width: "60%",
  },
  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#3498db",
    borderBottom: "2px solid #2980b9",
    paddingVertical: 10,
    borderRadius: 5,
  },
  tableHeaderText: {
    color: "#ffffff",
    fontWeight: "bold",
    fontSize: 14,
    textAlign: "center",
    flex: 1,
  },
  tableRow: {
    flexDirection: "row",
    paddingVertical: 10,
    borderBottom: "1px solid #ecf0f1",
  },
  cell: {
    flex: 1,
    fontSize: 13,
    paddingHorizontal: 8,
    textAlign: "center",
    color: "#2c3e50",
  },
  boldText: { fontWeight: "bold", color: "#34495e" },
  numericCell: { textAlign: "right" },
  highlightRed: {
    backgroundColor: "#e74c3c",
    color: "#ffffff",
    padding: 5,
    borderRadius: 5,
  },
  highlightGreen: {
    backgroundColor: "#2ecc71",
    color: "#ffffff",
    padding: 5,
    borderRadius: 5,
  },
  highlightYellow: {
    backgroundColor: "#f1c40f",
    color: "#ffffff",
    padding: 5,
    borderRadius: 5,
  },
  footer: {
    fontSize: 10,
    position: "absolute",
    bottom: 10,
    left: 0,
    right: 0,
    textAlign: "center",
    color: "#95a5a6",
  },
});

const getRowBackgroundColor = (index) =>
  index % 2 === 0 ? "#ffffff" : "#f8f9fa";

const PdfDocumentDutyFree = ({ data }) => {
  const { source, currency } = useSelector((store) => store.constant);
  return (
    <Document>
      {data && data.length > 0
        ? data.map((entry, index) => (
            <Page key={index} style={styles.page}>
              <View style={styles.headerSection}>
                <Text style={styles.documentTitle}>
                  Duty-Free Price Comparison
                </Text>
                <Text>
                  {new Intl.DateTimeFormat("en-US").format(new Date())}
                </Text>
              </View>

              <View style={styles.section}>
                <Text style={styles.header}>Common Data</Text>
                <View style={styles.commonDataRow}>
                  <Text style={styles.commonDataLabel}>Title:</Text>
                  <Text style={styles.commonDataValue}>
                    {String(
                      (Array.isArray(entry.products_data) &&
                        entry.products_data.find(p => p.website === source)?.title) ||
                        "N/A"
                    )}
                  </Text>
                </View>
                <View style={styles.commonDataRow}>
                  <Text style={styles.commonDataLabel}>Source Price:</Text>
                  <Text style={styles.commonDataValue}>
                    $
                    {convert_usd_to_nzd(
                      Number(entry.source_price || 0),
                      currency
                    )}
                  </Text>
                </View>
                <View style={styles.commonDataRow}>
                  <Text style={styles.commonDataLabel}>Source Price Rank:</Text>
                  <Text style={styles.commonDataValue}>
                    {String(entry.source_pricerank || "N/A")}
                  </Text>
                </View>
                <View style={styles.commonDataRow}>
                  <Text style={styles.commonDataLabel}>Category:</Text>
                  <Text style={styles.commonDataValue}>
                    {String(entry.products_data[0]?.category || "N/A")}
                  </Text>
                </View>
                <View style={styles.commonDataRow}>
                  <Text style={styles.commonDataLabel}>Brand:</Text>
                  <Text style={styles.commonDataValue}>
                    {String(entry.products_data[0]?.brand || "N/A")}
                  </Text>
                </View>
              </View>

              <View style={styles.section}>
                <Text style={styles.header}>Price Comparison</Text>
                <View style={styles.tableHeader}>
                  <Text style={styles.tableHeaderText}>Website</Text>
                  <Text style={styles.tableHeaderText}>Price</Text>
                  <Text style={styles.tableHeaderText}>Quantity + Unit</Text>
                  <Text style={styles.tableHeaderText}>Price/Unit</Text>
                  <Text style={styles.tableHeaderText}>Difference</Text>
                  <Text style={styles.tableHeaderText}>% Difference</Text>
                </View>
                {entry.products_data.map((product, productIndex) => {
                  const latestPrice = Number(product.latest_price || 0);
                  const qty = Number(product.qty || 1); // Prevent division by zero
                  const pricePerUnit = qty !== 0 ? latestPrice / qty : 0;
                  const sourcePricePerUnit =
                    Number(entry.source_price || 0) / qty;
                  const difference =
                    convert_usd_to_nzd(pricePerUnit, currency) -
                    convert_usd_to_nzd(sourcePricePerUnit, currency);
                  const percentageDifference = (
                    (difference / sourcePricePerUnit) *
                    100
                  ).toFixed(2);
                  const highlightStyle =
                    percentageDifference > 10
                      ? styles.highlightRed
                      : percentageDifference > 0
                      ? styles.highlightYellow
                      : styles.highlightGreen;

                  return (
                    <View
                      key={productIndex}
                      style={[
                        styles.tableRow,
                        {
                          backgroundColor: getRowBackgroundColor(productIndex),
                        },
                      ]}
                    >
                      <Text style={styles.cell}>
                        {String(product.website || "N/A")}
                      </Text>
                      <Text style={[styles.cell, styles.numericCell]}>
                        ${convert_usd_to_nzd(latestPrice, currency)}
                      </Text>
                      <Text style={styles.cell}>
                        {`${Number(product.qty || 0)} ${String(
                          product.unit || ""
                        )}`.trim()}
                      </Text>
                      <Text style={[styles.cell, styles.numericCell]}>
                        ${convert_usd_to_nzd(pricePerUnit, currency)}
                      </Text>
                      <Text style={[styles.cell, styles.numericCell]}>
                        ${difference.toFixed(2)}
                      </Text>
                      <Text style={[styles.cell, highlightStyle]}>
                        {String(percentageDifference)}%
                      </Text>
                    </View>
                  );
                })}
              </View>

              <Text style={styles.footer}>Page {index + 1}</Text>
            </Page>
          ))
        : null}
    </Document>
  );
};

export default PdfDocumentDutyFree;
